import React, { useContext, useEffect, useState } from "react";
import { Button } from "@mui/material";
import { Print } from "@mui/icons-material";
import * as XLSX from 'xlsx';

export const ExportDataXlsx = ({
  data,
  fileName,
  fontSize = "medium"
}) => {
  const handleExport = () => {
    const planilha = XLSX.utils.book_new();
    const planilhaDados = XLSX.utils.json_to_sheet(data);

    const range = XLSX.utils.decode_range(planilhaDados['!ref']);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      let maxLength = 0;
      for (let R = range.s.r; R <= range.e.r; ++R) {
        const cellAddress = { c: C, r: R };
        const cellRef = XLSX.utils.encode_cell(cellAddress);
        const cell = planilhaDados[cellRef];
        if (cell && cell.v) {
          const length = cell.v.toString().length;
          if (length > maxLength) maxLength = length;
        }
      }
      const colWidth = maxLength > 10 ? maxLength : 10;
      planilhaDados['!cols'] = planilhaDados['!cols'] || [];
      planilhaDados['!cols'][C] = { wch: colWidth };
    }

    XLSX.utils.book_append_sheet(planilha, planilhaDados, "Planilha1");

    XLSX.writeFile(planilha, `${fileName}.xlsx`);
  }

  return (
    <Button
      onClick={handleExport}
    >
      <Print fontSize={fontSize} />
    </Button>
  );
}